import { Button } from "./button";

export interface PaginationProps {
  /** 1-based current page. */
  page: number;
  /** Total number of pages (≥ 1). */
  pageCount: number;
  onPage: (page: number) => void;
  /** Localized labels — kept i18n-free here so the component stays presentational. */
  prevLabel: string;
  nextLabel: string;
  /** A short summary, e.g. "Page 2 of 5" or "21–40 of 93". */
  summary: string;
}

/**
 * Pager for server-paginated tables: Previous / Next plus a summary line. Presentational only —
 * the caller owns page state (typically synced to the URL) and passes localized labels. Hidden
 * when there's a single page.
 */
export function Pagination({ page, pageCount, onPage, prevLabel, nextLabel, summary }: PaginationProps) {
  if (pageCount <= 1) return null;
  return (
    <div className="pagination">
      <span className="pg-summary">{summary}</span>
      <div className="pg-actions">
        <Button variant="ghost" size="sm" icon="chevL" disabled={page <= 1} onClick={() => onPage(page - 1)}>
          {prevLabel}
        </Button>
        <Button
          variant="ghost"
          size="sm"
          iconRight="chevR"
          disabled={page >= pageCount}
          onClick={() => onPage(page + 1)}
        >
          {nextLabel}
        </Button>
      </div>
    </div>
  );
}
